export default __webpack_public_path__ + "static/media/drain.c4cac92c.svg";